import { ImageEdit } from "@pathwright/blocks/src/shared"
import { MediaIconButton } from "@pathwright/legacy-media-manager"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { GridContainer, GridImage } from "../ui"

const GridEdit = (props) => {
  const { data, onChange, columns } = props

  const handleUpdateImage = (i) => (image) => {
    let nextImages = [...data.images]
    nextImages[i] = { ...nextImages[i], src: image }
    onChange({ ...data, images: nextImages })
  }

  return (
    <Content.Container>
      <GridContainer>
        {data.images.slice(0, columns).map((image, i) => (
          <GridImage key={i} columns={columns}>
            <ImageEdit
              image={image.src}
              altText={image.altText}
              onChangeImage={handleUpdateImage(i)}
              renderButton={({ onClick }) => (
                <MediaIconButton
                  style={{
                    position: "absolute",
                    top: "0",
                    margin: "5px 0 0 -15px"
                  }}
                  onClick={onClick}
                  icon="shuffle"
                />
              )}
            />
          </GridImage>
        ))}
      </GridContainer>
    </Content.Container>
  )
}

export default GridEdit
